export const APOSTROPHE = '\x27';
export const COMMERCIAL_AT = '\x40';
export const DASH = '\u2013';
export const EXCLAMATION_MARK = '\x21';
export const NBSP = '\xa0';
export const SPACE = '\x20';
export const NBSPACE = '\u0020';
export const BULL = '\u2022';



// WEBPACK FOOTER //
// ./src/constants/chars.js